import '../estiloslogs.css'
import { SelectTarget } from './SelectTarget'
import { useEffect, useState } from 'react'
import { useAppSelector } from '../../../../../redux/hooks'
import { postUserLogs,postUserLogsTenant } from './request'
import { DateTimeFilter } from './DateTimeFilter'
import { Search } from '../../../../../_metronic/partials'

type Body = {
    typeChange?: any;
    target?: any;
    search?:any;
    startDate?:any;
    endDate?:any;
    page?: any;
    limit?: any;
};

function SearchLogs(props:any){
     {/*Aqui se colocan todas las constantes a utilizar*/}
        const tenant= useAppSelector(state =>state.TenantSlice.id)
        const Id = useAppSelector(state => state.SuscriptionSlice.id)
        const Type = useAppSelector(state => state.CloudSlice.Type)

        const [ActionType,setActionType]=useState('')
        const [TargetEnviar,setTargetEnviar]=useState<any>()
        const [Buscar,setSearch]=useState('')
        const [valueFecha, setValueFecha] =useState('');
        const [EndFecha, setEndFecha] =useState('');



     {/**************Se hace body para hacer filtro*********************/}

     function buildBody(typeChange:any, target:any,search:any,startDate:any,endDate:any,page: any, limit: any) {
        const body :Body={};
        if (typeChange !== undefined && typeChange!=='') {
            body.typeChange = typeChange;
        }
        if (target !== undefined&& target!=='') {
            body.target = target;
        }
        if (search !== undefined&& search!=='') {
            body.search = search;
        }
        if (startDate !== undefined&& startDate!=='') {
            body.startDate = startDate;
        }
        if (endDate !== undefined&& endDate!=='') {
            body.endDate = endDate;
        }

        if (page !== undefined && page!=='') {
            body.page = page;
        }
        if (limit !== undefined && limit!=='' ) {
            body.limit = limit;

        }

        return body;
    }

    {/**************Funcion para realizar la busqueda en la api*********************/}
   

    function fetchRecords(){
        const body = buildBody(ActionType, TargetEnviar,Buscar,valueFecha,EndFecha, props.currentPage, props.recordsPerPage);

        if(Id!==0 && tenant===0 && Type!=='Global'){
            postUserLogs(Id,body).then(response=>{
                props.setrecorsB(response.data)
                props.setTotalRecords(response.data.total);
            })
        }
        else if(tenant!==0 && Id!==0 && Type!=='Global'){

            postUserLogsTenant(Id,tenant,body).then(response=>{
                props.setrecorsB(response.data)
                props.setTotalRecords(response.data.total);
            })
        }
        else if(tenant===0 && Id===0 && Type==='Global'){

            postUserLogs(-1,body).then(response=>{
                props.setrecorsB(response.data)
                props.setTotalRecords(response.data.total);
            })
        }
        else if (tenant!==0 &&Id===0 && Type==='Global'){
            postUserLogsTenant(-1,tenant,body).then(response=>{
                props.setrecorsB(response.data)
                props.setTotalRecords(response.data.total);
            })
        }

     }
     useEffect(() => {
        if (props.currentPage|| props.recordsPerPage){
            fetchRecords();
        }
  
    }, [props.currentPage, props.recordsPerPage,TargetEnviar,ActionType]);

 
    useEffect(()=>{
        
        if(Buscar===''){
            fetchRecords()
        }
    },[Buscar])

    useEffect(()=>{
        
        if(tenant){
            fetchRecords()
        }
    },[Id])
  

    return(
        <>
        <section className="ordenar-inputs"> 
            <div className="input-h">
                <div>
                    <SelectTarget setTargetEnviar={setTargetEnviar}></SelectTarget>
                </div>
                <div>
                    <label className='form-label f-bold fs-p text-marino  form-label' htmlFor="type">Type</label>
                    <select className='form-select border-marino f-parrafo h-40px text-dk text-center w-200px' id='type'onChange={(e)=>setActionType(e.target.value)}>
                        <option value=''>All</option>
                        <option value="1">Create</option>
                        <option value="2">Update</option>
                        <option value="3">Delete</option>
                    </select>
                </div>
                
                <div>
                    <label className='form-label f-bold fs-p text-marino  form-label' htmlFor="type"></label>
                    <div className="input-group">
                    <input type="text" className='form-control w-300px border-marino f-parrafo h-40px' 
                    style={{marginTop:'12px'}}
                    onChange={(e)=>setSearch(e.target.value)}
                    placeholder='Search for Username or Email'
                    />
                    <button style={{marginTop:'12px', padding:'10px'}} className="btn btn-outline-secondary border border-marino h-40px" type="button" onClick={fetchRecords}>
                        <i className="bi bi-search"></i> 
                    </button>

                    </div>
                </div>

                {/*<div className="d-flex flex-column flex-row-auto margen ">
                    {<button type='submit'  className="btn-gradiente" style={{width:'100px',padding:'10px', height:'40px'}} onClick={fetchRecords}>Search</button>} 
                </div>*/}

                <div>
                </div>              
            </div>   
        </section>
        <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
            <DateTimeFilter setValueFecha={setValueFecha} valueFecha={valueFecha} setEndFecha={setEndFecha}  EndFecha={EndFecha}fetchRecords={fetchRecords}></DateTimeFilter>
        </div>
        </>
    )
}
export {SearchLogs}